import { apiService } from './ApiService';
import { Settings, Store } from '../wrappers';
import AppEvent from '../models/AppEvent';
import Pusher from 'pusher-js';
class WebsocketsService {
    client;
    websocketChannel;
    init() {
        const appKey = Settings.env.PUSHER_APP_KEY;
        const wsHost = Settings.env.PUSHER_HOST;
        const wsPort = Settings.env.PUSHER_PORT ? +Settings.env.PUSHER_PORT : 6002;
        if (!appKey || !wsHost)
            return;
        this.client = new Pusher(appKey, {
            wsHost: wsHost,
            wsPort: wsPort,
            wssPort: wsPort,
            forceTLS: false,
            enableStats: false,
            enabledTransports: ['ws', 'wss'],
            cluster: 'eu'
        });
        this.client.connection.bind('connected', () => {
            apiService.setSocketIdHeader(this.client?.connection.socket_id || null);
        });
        this.client.connection.bind('disconnected', () => {
            apiService.removeSocketIdHeader();
        });
    }
    reload() {
        if (!this.client)
            return;
        if (this.websocketChannel) {
            this.websocketChannel.unbind_all();
            this.websocketChannel = undefined;
        }
        const tenant = Store.get('tenant');
        if (!tenant)
            return;
        this.websocketChannel = this.client.subscribe(`notifications.${tenant.hash}`);
        this.websocketChannel.bind('App\\Events\\Notification', (event) => {
            console.log('Websocket event received: ' + event.type);
            AppEvent.handle(event);
        });
    }
    get connectionStatus() {
        return this.client?.connection.state;
    }
}
export const websocketsService = new WebsocketsService();
export default websocketsService;
//# sourceMappingURL=WebsocketsService.js.map